import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { FormatTypes } from '../../../../../../constants/templateDictionaries';
import { Tooltip } from '../../../UI/Editor/MostUsedToolset/tooltip';
import RenameDocuments from './renameDocuments';
import SnackBarAlerts from '../../../../../common/snackBarAlerts/snackBarAlerts';
import Actions from '../../../../../../store/actions';
import breakpointsMinWidth from '../../../../../../styling/breakpointsMinWidth';
import { GrayBorder } from '../../../../../../styling/theme';
import { DOCUMENT_NAMES_MAP } from './documentNamesMap';

const CommonStyles = styled.div`
  display: inline-block;
  font-size: 12px;
  color: #333d47;
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;

const DocumentNameWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const fadeIn = keyframes`
from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

const DocumentName = styled(CommonStyles)`
  display: inline-block;
  position: relative;
  max-width: 180px;
  padding: 0 4px;
  border-radius: 2px;
  border: 1px solid #fff;
  cursor: text;

  &:hover {
    border: ${GrayBorder};
    div {
      display: block;
      animation: ${fadeIn} 0.2s ease-in;
    }
  }
`;

const DocumentNameText = styled.span`
  display: inherit;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const Connector = styled(CommonStyles)`
  padding: 0 4px;
`;

const TemplateType = styled(CommonStyles)`
  text-transform: capitalize;
  width: max-content;
`;

const EditorDocumentName = (props) => {
  const { documentId, updateDocumentName, formatType } = props;

  const { documentName } = props;

  const [isRename, setIsRename] = useState(false);
  const [updatedDocumentName, setUpdatedDocumentName] = useState(documentName);

  const [showSnackBar, setShowSnackBar] = useState(false);
  const [snackBarType, setSnackBarType] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');

  const handleUpdateIsEditing = (value) => {
    setIsRename(value);
  };

  const setUpdateDocumentName = (status, value) => {
    if (status === 'success') {
      setUpdatedDocumentName(value);
      updateDocumentName({ documentName: value, formatType });
    } else if (status === 'error') {
      setUpdatedDocumentName(documentName);
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setUpdatedDocumentName(value);
  };

  const setSnackBarState = (show, type, message) => {
    if (type === 'error') {
      setUpdatedDocumentName(documentName);
      setShowSnackBar(show);
      setSnackBarMessage(message);
      setSnackBarType(type);
    }
  };

  const handelSnackBar = (response) => {
    const { status, message } = response;

    setSnackBarState(true, status ? 'success' : 'error', message);
  };

  const handleUpdateDocumentName = (response, value) => {
    const { status } = response;

    setUpdateDocumentName(status ? 'success' : 'error', value);
  };

  const handleCloseSnackBar = () => {
    setShowSnackBar(false);
  };

  /**
   * TODO: This needs to vary as per the device
   */

  return (
    <>
      <SnackBarAlerts
        showSnackBar={showSnackBar}
        handleClose={handleCloseSnackBar}
        snackBarMessage={snackBarMessage}
        snackBarType={snackBarType}
      />
      <DocumentNameWrapper>
        {isRename ? (
          <RenameDocuments
            documentName={documentName}
            nodeId={documentId}
            isEditing={isRename}
            handleChange={handleChange}
            handleUpdateDocumentName={handleUpdateDocumentName}
            handleUpdateIsEditing={handleUpdateIsEditing}
            handelSnackBar={handelSnackBar}
            formatType={formatType}
          />
        ) : (
          <DocumentName onClick={() => setIsRename(true)}>
            <DocumentNameText aria-label="Edit document">
              {updatedDocumentName || documentName}
            </DocumentNameText>
            <Tooltip top="28px">{updatedDocumentName || documentName}</Tooltip>
          </DocumentName>
        )}
        <Connector>-</Connector>
        <TemplateType>{DOCUMENT_NAMES_MAP[formatType]}</TemplateType>
      </DocumentNameWrapper>
    </>
  );
};

EditorDocumentName.propTypes = {
  documentName: propTypes.string,
  documentId: propTypes.string,
};

EditorDocumentName.defaultProps = {
  documentName: '',
  documentId: '',
};

const mapStateToProps = (state, ownProps) => {
  const { formatType } = ownProps;

  if (formatType === FormatTypes.JOURNAL) {
    return {
      templateType: state.editJournalFormReducer.templateType,
      documentName: state.editJournalFormReducer.documentName,
      documentId: state.editJournalFormReducer.documentId,
    };
  }

  if (formatType === FormatTypes.RESUME) {
    return {
      templateType: state.editResumeFormReducer.templateType,
      documentName: state.editResumeFormReducer.documentName,
      documentId: state.editResumeFormReducer.documentId,
    };
  }

  if (formatType === FormatTypes.COVER_LETTER) {
    return {
      templateType: state.editCoverLetterFormReducer.templateType,
      documentName: state.editCoverLetterFormReducer.documentName,
      documentId: state.editCoverLetterFormReducer.documentId,
    };
  }

  if (formatType === FormatTypes.AI_MOCK_INTERVIEW) {
    return {
      templateType: state.interviewFile.templateType,
      documentName: state.interviewFile.documentName,
      documentId: state.interviewFile.documentId,
    };
  }
  if (formatType === FormatTypes.CAREER_FINANCIALS) {
    return {
      templateType: state.careerFinancials?.templateType,
      documentName: state.careerFinancials?.documentName,
      documentId: state.careerFinancials?.documentId,
    };
  }

  return null;
};

const mapDispatchToProps = (dispatch) => ({
  updateDocumentName: (params) => {
    dispatch(Actions.editDocumentFormActions.updateDocumentName(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EditorDocumentName);
